import React, { useEffect, useState } from 'react';
import { RadioButton } from './radio-button';
import styled from '@emotion/styled';
import { getSpacing } from '@cabonline/ui-shared';
import { StyledRequired } from '../form';
import { Label } from '../label';

interface StyledRadioGroupProps {
  row?: boolean;
}

const StyledRadioGroup = styled.div<StyledRadioGroupProps>`
  display: flex;
  flex-direction: ${(p) => (p.row ? 'row' : 'column')};
  gap: ${(p) => (p.row ? getSpacing('s') : getSpacing('xxs'))};
`;

interface RadioGroupProps {
  options: Array<{
    label: string;
    value: string;
    disabled?: boolean;
  }>;
  defaultValue?: string;
  onChange: (value: string) => void;
  row?: boolean;
  label?: string;
  required?: boolean;
  testID?: string;
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  options,
  defaultValue,
  onChange,
  row = false,
  label,
  required = false,
  testID = '',
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue || '');

  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== selectedValue) {
      setSelectedValue(defaultValue);
    }
  }, [defaultValue]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedValue(event.target.value);
    onChange(event.target.value);
  };

  return (
    <>
      {label && (
        <Label>
          {label}
          {required && <StyledRequired aria-hidden />}
        </Label>
      )}
      <StyledRadioGroup row={row}>
        {options.map((option, i) => (
          <RadioButton
            key={`radioGroupRow-${i}`}
            label={option.label}
            value={option.value}
            checked={selectedValue === option.value}
            onChange={handleChange}
            testID={`${testID}-${option.value}`}
            disabled={option.disabled}
          />
        ))}
      </StyledRadioGroup>
    </>
  );
};
